import React from "react";
import Ui from "../../components/list/Ul";
import Li from "../../components/list/Li";

const ImageList = ({ items, spacing = "ml-2" }) => {
  return (
    <Ui className="list-disc py-2">
      {items.map(({ icon, color, text, description }, idx) => (
        <div>
          <Li key={idx} className="flex items-start  py-2 li-marker-disc">
            <span
              className={`${spacing} mt-1 text-${color}-500 flex-shrink-0`}
              style={{ lineHeight: 1 }}
            >
              {icon}
            </span>
            <span
              className="leading-tight text-gray-900 text-xl font-bold"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </Li>
          <span
            className="leading-tight text-gray-900 text-lg"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      ))}
    </Ui>
  );
};

export default ImageList;
